module.exports = __webpack_public_path__ + "log grey-bd961bdbf87594589fff.svg";